// src/components/Purchase.js

import React, { useState } from 'react';
import { Button, TextField, Typography, Alert, Box } from '@mui/material';
import axios from 'axios';
import { loadStripe } from '@stripe/stripe-js';

// Replace with your Stripe public key
const stripePromise = loadStripe('pk_test_51Q0vBfRuB4ANwoYPaK18isTEv89pU7JDL2O5d9kgjxqiDHxZhWmPCneDFLjBY28BRaxykBA4bM0yNFaW4L0P6XaX00FwPfMa8A');

const Purchase = ({ userId, onPurchaseSuccess }) => {
  const [amount, setAmount] = useState(500);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handlePurchase = async () => {
    setError('');
    setLoading(true);
    try {
      const response = await axios.post(
        'https://create-checkout-session-5ai7wqmgta-uc.a.run.app',
        {
          amount: amount, // Amount in cents
          userId,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      );

      const { url } = response.data;
      console.log(url);
      if (url) {
        window.location.href = url;
      } else {
        setError('Checkout URL not found.');
      }
    } catch (err) {
      setError(
        err.response?.data?.error ||
          'An error occurred during the purchase process. Please try again later.'
      );
    } finally {
      setLoading(false);
    }
  };

  const handleAmountChange = (e) => {
    const value = parseInt(e.target.value, 10);
    if (isNaN(value)) {
      setError('Please enter a valid number.');
      return;
    }
    if (value < 500) {
      setError('Amount must be at least 500.');
    } else {
      setError('');
      setAmount(value);
    }
  };

  return (
    <Box
      sx={{
        width: '100%',
        maxWidth: '400px',
        mt: 4,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
      }}
    >
      <Typography variant="h6" sx={{ mb: 2 }}>
        Purchase Energy
      </Typography>

      {error && (
        <Alert
          severity="error"
          sx={{
            mb: 2,
            width: '100%',
            textAlign: 'center',
            backgroundColor: '#1a1a1a',
            color: '#ffffff',
            borderRadius: '4px',
            border: '1px solid #333',
          }}
        >
          {error}
        </Alert>
      )}

      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          width: '100%',
        }}
      >
        <TextField
          label="Enter amount to buy"
          type="number"
          value={amount}
          onChange={handleAmountChange}
          inputProps={{ min: 500, step: 100 }}
          sx={{
            flexGrow: 1,
            backgroundColor: '#000000', // Changed to black
            borderRadius: '4px',
            mr: 1,
            '& .MuiInputBase-root': {
              color: 'white', // Changed to white for better visibility on black background
            },
            '& .MuiOutlinedInput-root': {
              '& fieldset': {
                borderColor: '#cccccc',
              },
              '&:hover fieldset': {
                borderColor: '#999999',
              },
              '&.Mui-focused fieldset': {
                borderColor: '#666666',
              },
            },
            '& .MuiInputLabel-root': {
              color: '#ffffff', // Changed to white for better visibility on black background
            },
          }}
          aria-label="Amount to purchase energy"
        />

        <Button
          variant="contained"
          onClick={handlePurchase}
          disabled={loading || amount < 500}
          sx={{
            backgroundColor: '#1a1a1a',
            color: '#ffffff',
            paddingX: 3,
            paddingY: 1,
            '&:hover': {
              backgroundColor: 'grey.700',
            },
          }}
          aria-label="Buy energy"
        >
          {loading ? 'Processing...' : 'Buy'}
        </Button>
      </Box>
    </Box>
  );
};

export default Purchase;
